<div class="modal-header">
  <h5 class="modal-title">{{ barCode.id ? 'Chỉnh Sửa' : 'Thêm' }} Mã Vạch</h5>
  <button type="button" class="close" aria-label="Đóng" (click)="onCancelClick()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form>
    <div class="form-group">
      <label for="isbn">
        ISBN
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" 
           title="<b>Mô Tả:</b> Nhập Mã Số Sách Chuẩn Quốc Tế (ISBN)."></i>
      </label>
      <input type="text" class="form-control" id="isbn" [(ngModel)]="barCode.isbn" 
             name="isbn" placeholder="ví dụ: 978-3-16-148410-0" value="978-3-16-148410-0">
    </div>
    
    <div class="form-group">
      <label for="type">
        Loại
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" 
           title="<b>Mô Tả:</b> Chỉ định loại mã vạch."></i>
      </label>
      <ng-select 
        [items]="[ 'Code128', 'Code39', 'EAN13', 'UPC']" 
        [(ngModel)]="barCode.type" 
        name="type" 
        placeholder="Chọn loại">
      </ng-select>
    </div>
  
    <div class="form-group">
      <label for="width">
        Chiều Rộng
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" 
           title="<b>Mô Tả:</b> Đặt chiều rộng của mã vạch."></i>
      </label>
      <input type="number" class="form-control" id="width" [(ngModel)]="barCode.width" 
             name="width" placeholder="ví dụ: 2" value="2">
    </div>
  
    <div class="form-group">
      <label for="height">
        Chiều Cao
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" 
           title="<b>Mô Tả:</b> Đặt chiều cao của mã vạch."></i>
      </label>
      <input type="number" class="form-control" id="height" [(ngModel)]="barCode.height" 
             name="height" placeholder="ví dụ: 1" value="1">
    </div>
  
    <div class="form-group">
      <label for="displayValue">
        Hiển Thị Giá trị
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" 
           title="<b>Mô Tả:</b> Kiểm tra để hiển thị giá trị dưới mã vạch."></i>
      </label>
      <input type="checkbox" class="form-control" id="displayValue" 
             [(ngModel)]="barCode.displayValue" name="displayValue">
    </div>
  
    <div class="form-group">
      <label for="font">
        Font
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" 
           title="<b>Mô Tả:</b> Chỉ định font cho văn bản mã vạch."></i>
      </label>
      <ng-select 
        [items]="['Arial', 'Verdana', 'Times New Roman', 'Courier New']" 
        [(ngModel)]="barCode.font" 
        name="font" 
        placeholder="Chọn font">
      </ng-select>
    </div>
  
    <div class="form-group">
      <label for="color">
        Color
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" 
           title="<b>Mô Tả:</b> Chỉ định màu của mã vạch."></i>
      </label>
      <ng-select 
        [items]="['Black', 'Red', 'Blue', 'Green']" 
        [(ngModel)]="barCode.color" 
        name="color" 
        placeholder="Chọn color">
      </ng-select>
    </div>
  
    <div class="form-group">
      <label for="margin">
        Margin
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" 
           title="<b>Mô Tả:</b> Đặt margin quanh mã vạch."></i>
      </label>
      <input type="number" class="form-control" id="margin" [(ngModel)]="barCode.margin" 
             name="margin" placeholder="ví dụ: 5" value="5">
    </div>
  
    <div class="form-group">
      <label for="rotation">
        Rotation
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" 
           title="<b>Mô Tả:</b> Đặt góc xoay của mã vạch."></i>
      </label>
      <input type="number" class="form-control" id="rotation" [(ngModel)]="barCode.rotation" 
             name="rotation" placeholder="ví dụ: 0" value="0">
    </div>
  </form>
  
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="onCancelClick()">Cancel</button>
  <button type="button" class="btn btn-outline-primary" (click)="onSaveClick()">Save</button>
</div>

